export default "__VITE_ASSET__DNe2lMq$__"